module.exports = __webpack_public_path__ + "static/media/mmt symbols.71a51e7a.png";